import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getMemberMigrationSectors = async (HubIds: string[]) => {
    const { path, method } = endpoints.occupationAndSector.getMemberMigrationSectors;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
